"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defineKey = void 0;

var defineKey = function defineKey(arg) {
  return arg;
};

exports.defineKey = defineKey;